import axios from "axios";

export const API = axios.create({
  baseURL: "http://data.gune.kr.s3.amazonaws.com/",
  timeout: 20000,
  headers: {
    "Cache-Control": "no-cache",
  },
});

export function S3Service() {
  delete API.defaults.headers.common["Authorization"];
  return API;
}
